import { FC } from 'react'
import { TextSkeleton, VStack } from '@revolut-internal/ui-kit'

import { ChatMessageLoading } from 'components'

import { chatMessagesListWidth } from './ChatMessagesList.constants'

export const ChatMessagesListLoading: FC = () => {
  return (
    <VStack width={chatMessagesListWidth} gap="s-16" align="center">
      <TextSkeleton width={120} height={18} />
      <ChatMessageLoading placement="right" chatHeight={72} />
      <ChatMessageLoading chatHeight={216} />
      <ChatMessageLoading placement="right" chatWidth={420} />
      <ChatMessageLoading chatHeight={144} />
      <TextSkeleton width={120} height={18} />
      <ChatMessageLoading placement="right" chatWidth={200} />
      <ChatMessageLoading chatWidth={360} />
    </VStack>
  )
}
